import { breakElementLines } from './utils/functions';

class Underlines {
	constructor() {
		this.drawUnderlines = this.drawUnderlines.bind(this);
	}

	init() {
		let initialAnimation = true;
		let width = window.innerWidth;
		let resizeDebouncer: ReturnType<typeof setTimeout>;
		const delay = 200;
		window.addEventListener('resize', () => {
			if (initialAnimation || window.innerWidth !== width) {
				clearTimeout(resizeDebouncer);
				resizeDebouncer = setTimeout(this.drawUnderlines, delay);
				initialAnimation = false;
				width = window.innerWidth;
			}
		});
		window.dispatchEvent(new Event('resize'));
	}

	drawUnderlines() {
		breakElementLines({ element: '.has-rainbow-underline', class: 'heading-underline' });
		const underlineElements = document.querySelectorAll('.heading-underline');
		if (underlineElements) {
			underlineElements.forEach((highlight) => {
				highlight.innerHTML += window.sageUnderline;
			});
		}
	}
}

export default new Underlines();
